import { ViewAllWorksWrapper } from "../../styles/StyledComponents/ServiceCompWrapper";
import CommonButton from "../../ui/CommonButton/CommonButton";
import assests from "../../ui/assests";
import CommonHeading from "../CommonHeading/CommonHeading";

const ViewAllWorks = () => {
  return (
    <ViewAllWorksWrapper className="cmn_gap">
      <div className="container">
        <div className="viewWorks_card">
          <figure className="viewSection_bg">
            <img src={assests.viewSectionImg} alt="viewSectionImg" />
          </figure>
          <CommonHeading
            className="view_description_heading"
            title="Our Work Speaks Louder"
            paratext="We’ve helped brands across industries stand out online. Explore our portfolio to see how design meets results."
          >
            <CommonButton
              variant="contained"
              color="primary"
              className="view_works_btn"
            >
              View All Works
            </CommonButton>
          </CommonHeading>
        </div>
      </div>
    </ViewAllWorksWrapper>
  );
};

export default ViewAllWorks;
